import React, { useEffect, useState } from 'react';

import {
  Button,
  Typography,
  Icon,
  toast,
  Toastify,
  useDeviceType,
} from 'pixel-react';
import { Link } from 'react-router-dom';

import WEBSITE_ENVIRONMENT_URL_CONFIG from '@/config/website-env-url-config';
import { useReSendActivationMutation } from '@/store/resetActivationLink/resetActivationLinkSlice';
import type { SignUpResponse } from '@/types/signUp';

import styles from './RegistrationSuccess.module.scss';
import { SignUpWrapper } from '../SignUpWrapper';
export const RegistrationSuccess: React.FC = () => {
  const clientName = import.meta.env.VITE_CLIENT_DETAIL?.name;
  const [resendActivationLink, { isLoading }] = useReSendActivationMutation();
  const { isMobile } = useDeviceType();
  const [email, setEmail] = useState<string | null>(null);

  useEffect(() => {
    const search = window.location.search;
    const email = new URLSearchParams(search).get('email');

    setEmail(email);
  }, []);

  const handleSubmit = async () => {
    try {
      const payLoad = { emailId: email };
      const response = (await resendActivationLink(
        payLoad,
      ).unwrap()) as SignUpResponse;
      if (response.responseCode === 200) {
        toast.success(response?.message);
      } else if (response.responseCode === 429) {
        toast.info(
          response?.message || 'Too many requests. Please try again later.',
        );
      }
    } catch (error) {
      console.error('Login failed. Please check your credentials.', error);
    }
  };

  return (
    <SignUpWrapper
      content_header={
        <>
          {' '}
          <Typography fontSize="24px" fontWeight="bold">
            {clientName} AI - Better at being the best
          </Typography>{' '}
        </>
      }
      sub_content={`Using ${clientName}, our customers reap 10x faster scripting, 74% reduction in cost & 54% reduction in maintenance efforts, all at their fingertips`}
      footer_content={`${clientName}: High Speed Testing, Simplified!`}
      copyright_content={`Copyright © ${clientName} Pvt Ltd. All Rights Reserved`}
      className={styles.activation_container}
    >
      <section className={styles.form_container}>
        <aside className={styles.activation_form}>
          <section className={styles['icon_container']}>
            <Icon
              color=""
              height={isMobile ? 160 : 240}
              width={isMobile ? 160 : 240}
              name="user_with_system"
            />
          </section>
          <section className={styles.activation_form_header}>
            <Typography
              fontSize="32px"
              textAlign="center"
              className={styles['header_text']}
            >
              Registration Successful !
            </Typography>

            <Typography
              fontSize="16px"
              textAlign="center"
              lineHeight="22px"
              className={styles['sub_header_text']}
            >
              <Typography
                fontSize="16px"
                textAlign="center"
                lineHeight="22px"
                className={styles['highlighted_text']}
              >
                Congratulations!
              </Typography>{' '}
              Your registration has been successful. you are now a member of our
              community.
            </Typography>

            <Typography
              fontSize="16px"
              textAlign="center"
              lineHeight="22px"
              className={`${styles['highlighted_text']} ${styles['icon_container_text']}`}
            >
              Welcome Aboard
            </Typography>
            <Typography
              fontSize="16px"
              textAlign="center"
              lineHeight="22px"
              className={styles['sub_header_text']}
            >
              {' '}
              To complete your Account, Please check your email and get
              Activated.
            </Typography>
          </section>

          <div className={styles.activation_footerbtn}>
            <div className={styles.footerBtn_container}>
              <div className={styles.activation_footerbtn}>
                <Button
                  type="submit"
                  buttonWidth="219px"
                  variant="primary"
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  <Typography
                    fontSize="16px"
                    className={styles['register_btn']}
                  >
                    Resend Activation Link
                  </Typography>
                </Button>
              </div>
              <div className={styles.backward_footerbtn}>
                <Link to={WEBSITE_ENVIRONMENT_URL_CONFIG?.LOCAL_HOST}>
                  <Button type="button" buttonWidth="233px" variant="secondary">
                    <Typography
                      fontWeight="bold"
                      color="var(--brand-color)"
                      fontSize="16px"
                    >
                      Back to Sign in
                    </Typography>
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </aside>
      </section>
      <Toastify />
    </SignUpWrapper>
  );
};
